import { ThemeOptions, createTheme } from "@mui/material/styles";
import "./types";
import breakpoints from "./breakpoints";
import colors from "./colors";
import fonts from "./fonts";
import palette from "./palette";
import styleOverrides from "./styleOverrides";
import typography from "./typography";

export type { Colors } from "./colors";
export type { Fonts } from "./fonts";

export const themeOptions: ThemeOptions = {
  palette,
  breakpoints: {
    values: breakpoints.values,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides,
    },
  },
  colors,
  fonts,
  typography,
};

const theme = createTheme(themeOptions);

export default theme;
